import React, { useState, useMemo, MouseEvent } from 'react';
import {
  Link,
  Section,
  SectionSubTitle,
  SelectionGroup,
  SelectionGroupOption,
  SelectionGroupValue,
  Typography,
} from 'common/components';
import { createElementKey } from 'utils';
import { analyticsUtils } from 'utils/analytics-utils';
import { KITCHEN_ELEMENT_BLOCK } from 'landings/kitchen/kitchen-constants';
import {
  NEW_KITCHEN_CATEGORIES_MAP,
  NEW_KITCHEN_CATEGORIES_TAB_LIST,
  NewKitchenCategoriesTabName,
  NewKitchenCategoryStructure,
} from './new-kitchen-categories-section-constants';
import {
  newKitchenCategoriesGridStylesMap,
  newKitchenCategoriesSectionItem,
  newKitchenCategoriesSectionItemImage,
  newKitchenCategoriesSectionItemImageWrapper,
  newKitchenCategoriesSectionItemName,
  newKitchenCategoriesSectionTabs,
  StyledNewKitchenCategoriesGrid,
} from './new-kitchen-categories-section-styles';

export const NewKitchenCategoriesSection: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState(NewKitchenCategoriesTabName.BuiltInAppliances);

  const newKitchenCategoriesList = useMemo(() => NEW_KITCHEN_CATEGORIES_MAP[activeCategory], [
    activeCategory,
  ]);

  const handleCategoryTabChange = (_: MouseEvent, value: SelectionGroupValue) => {
    setActiveCategory(value as NewKitchenCategoriesTabName);

    const activeCategoryTabName: SelectionGroupOption | undefined = NEW_KITCHEN_CATEGORIES_TAB_LIST.find(
      (option: SelectionGroupOption) => option.value === value
    );

    if (activeCategoryTabName) {
      analyticsUtils.clickButtonEvent(
        KITCHEN_ELEMENT_BLOCK,
        activeCategoryTabName.text,
        'Всё для удобной и стильной кухни'
      );
    }
  };

  const handleCategoryClick = (clickedItem: NewKitchenCategoryStructure) => () => {
    analyticsUtils.clickButtonEvent(
      KITCHEN_ELEMENT_BLOCK,
      clickedItem.name,
      'Всё для удобной и стильной кухни'
    );
  };

  const handleCategoryWheelClick = (clickedItem: NewKitchenCategoryStructure) => (e: MouseEvent) => {
    if (e.button === 1) {
      handleCategoryClick(clickedItem)();
    }
  };

  return (
    <Section>
      <SectionSubTitle margin="m">Всё для удобной и&nbsp;стильной кухни</SectionSubTitle>
      <SelectionGroup
        className={newKitchenCategoriesSectionTabs}
        isDesktopNoSwiping
        active={activeCategory}
        onChange={handleCategoryTabChange}
        optionList={NEW_KITCHEN_CATEGORIES_TAB_LIST}
        rounded
      />
      <StyledNewKitchenCategoriesGrid
        categoriesNumber={newKitchenCategoriesList.length}
        className={newKitchenCategoriesGridStylesMap[newKitchenCategoriesList.length]}>
        {newKitchenCategoriesList.map((category, index) => (
          <li key={createElementKey('kitchen-category', index)}>
            <Link
              onClick={handleCategoryClick(category)}
              onAuxClick={handleCategoryWheelClick(category)}
              className={newKitchenCategoriesSectionItem}
              title={category.name}
              href={category.href}>
              <div className={newKitchenCategoriesSectionItemImageWrapper}>
                <img
                  className={newKitchenCategoriesSectionItemImage}
                  src={category.image}
                  alt={category.name}
                  width="80"
                  height="80"
                />
              </div>
              <Typography className={newKitchenCategoriesSectionItemName} variant="s" size="body_long">
                {category.name}
              </Typography>
            </Link>
          </li>
        ))}
      </StyledNewKitchenCategoriesGrid>
    </Section>
  );
};
